import { render, staticRenderFns } from "./IssueStatusBtn.vue?vue&type=template&id=999c0036&scoped=true&"
import script from "./IssueStatusBtn.vue?vue&type=script&lang=ts&"
export * from "./IssueStatusBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999c0036",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
